import type { HotspotUserStatus, PppoeClientStatus, RouterStatus, ServiceKind, VoucherBatchStatus } from '../api/types';
import { Badge, type BadgeTone } from './ui';

const ROUTER_LABELS: Record<RouterStatus, { label: string; tone: BadgeTone }> = {
  ONLINE: { label: 'En línea', tone: 'ok' },
  OFFLINE: { label: 'Sin conexión', tone: 'bad' },
  AUTH_ERROR: { label: 'Credencial rechazada', tone: 'bad' },
  UNKNOWN: { label: 'Sin sondear', tone: 'neutral' },
};

export function RouterStatusBadge({ status }: { status: RouterStatus }) {
  const { label, tone } = ROUTER_LABELS[status];
  return <Badge tone={tone}>{label}</Badge>;
}

const USER_LABELS: Record<HotspotUserStatus, { label: string; tone: BadgeTone }> = {
  ACTIVE: { label: 'Activo', tone: 'ok' },
  DISABLED: { label: 'Bloqueado', tone: 'warn' },
  EXPIRED: { label: 'Caducado', tone: 'neutral' },
  // No es un estado de reposo: significa que el router todavía no tiene la credencial.
  PENDING_SYNC: { label: 'Pendiente en router', tone: 'bad' },
  DELETED: { label: 'Eliminado', tone: 'neutral' },
};

export function HotspotUserStatusBadge({ status, timeConsumed = false }: { status: HotspotUserStatus; timeConsumed?: boolean }) {  const { label, tone } = timeConsumed && status === 'EXPIRED'    ? { label: 'Tiempo agotado', tone: 'bad' as BadgeTone }    : USER_LABELS[status];  return <Badge tone={tone}>{label}</Badge>;}

const CLIENT_LABELS: Record<PppoeClientStatus, { label: string; tone: BadgeTone }> = {
  ACTIVE: { label: 'Activo', tone: 'ok' },
  // En un cliente fijo el bloqueo casi siempre es un corte por impago.
  DISABLED: { label: 'Suspendido', tone: 'warn' },
  EXPIRED: { label: 'Cortado', tone: 'bad' },
  PENDING_SYNC: { label: 'Pendiente en router', tone: 'bad' },
  DELETED: { label: 'Eliminado', tone: 'neutral' },
};

export function PppoeClientStatusBadge({ status }: { status: PppoeClientStatus }) {
  const { label, tone } = CLIENT_LABELS[status];
  return <Badge tone={tone}>{label}</Badge>;
}

export function ServiceBadge({ service }: { service: ServiceKind }) {
  return <Badge tone={service === 'PPPOE' ? 'info' : 'neutral'}>{service === 'PPPOE' ? 'PPPoE' : 'HotSpot'}</Badge>;
}

const BATCH_LABELS: Record<VoucherBatchStatus, { label: string; tone: BadgeTone }> = {
  PENDING: { label: 'Creando en router…', tone: 'info' },
  COMPLETED: { label: 'Completo', tone: 'ok' },
  PARTIAL: { label: 'Parcial', tone: 'warn' },
  FAILED: { label: 'Fallido', tone: 'bad' },
};

export function VoucherBatchStatusBadge({ status }: { status: VoucherBatchStatus }) {
  const { label, tone } = BATCH_LABELS[status];
  return <Badge tone={tone}>{label}</Badge>;
}

export function RoleBadge({ role }: { role: string }) {
  const tone: BadgeTone = role === 'SUPER_ADMIN' ? 'info' : 'neutral';
  const label = role === 'SUPER_ADMIN' ? 'Super admin' : 'Operador';
  return <Badge tone={tone}>{label}</Badge>;
}
